// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3D1QI","rootCenter":"LoadMoreObserver_rootCenter__2ovVq","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__8KcOe"};